// This file is auto-generated during build. Do not edit manually.
export const SDK_VERSION = '1.0.0' as const
